import { AbstractControl } from '@angular/forms';

import { NAME_PATTERNS } from '@com-delta-idp/mnx-sitewide-shared-utils';
import { nameConfig, regexList } from './regex-list';

// eslint-disable-next-line complexity
export function UsernameSkyMilesNumberEmailValidator(
  control: AbstractControl
): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value?.match(regexList.userIdLength)) {
    if (value.match(regexList.skyMilesNumber)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    } else if (
      value.match(regexList.userName) &&
      value.match(regexList.isNaN)
    ) {
      return <{ [s: string]: boolean }>(<unknown>null);
    } else if (value.match(regexList.email)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
  }
  return { INVALID_SKYMILES_NUMBER: true };
}

export function SkyMilesNumberValidator(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value?.match(regexList.userIdLength)) {
    if (value.match(regexList.skyMilesNumber)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
  }
  return { INVALID_SKYMILES_NUMBER: true };
}

export function nameRegex(value: string | undefined, key: string) {
  if (nameConfig.nameLengthConfig) {
    return value?.match(NAME_PATTERNS[key as keyof typeof NAME_PATTERNS]);
  } else {
    return (
      value?.match(regexList[key + 'Length']) && value.match(regexList[key])
    );
  }
}

export function FirstNameValidator(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value && nameRegex(value, 'FIRST_NAME_REGEX')) {
    return <{ [s: string]: boolean }>(<unknown>null);
  }
  return { FIRSTNAME_NO_MATCH: true };
}

export function LastNameValidator(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value && nameRegex(value, 'LAST_NAME_REGEX')) {
    return <{ [s: string]: boolean }>(<unknown>null);
  }
  return { INVALID_LASTNAME: true };
}
